import dayjs from "dayjs";
import * as _ from "lodash";

import { types } from "@/actions/topbar";

const initialState = {
    options: {
        autoHideTopBar: false,
        showLastBleId: true,
        gridVisible: true,
        snapping: true,
        apertureVisible: true,
        backgroundVisible: true,
        lightOpacity: 75,
    },
    advancedOperationsVisibility: false,
    visibility: true,
    lastRunDuplicate: dayjs().format(),
};

/**
 * Reducer for the top bar state including visibility, options, and timestamps.
 *
 * @param state - The current top bar state.
 * @param root0 - The dispatched action.
 * @param root0.payload - The action payload.
 * @param root0.type - The action type.
 * @returns The next top bar state.
 */
export default (state = initialState, { payload, type }) => {
    switch (type) {
        case types.SET_ADVANCED_OPERATIONS_VISIBILITY:
            return {
                ...state,
                advancedOperationsVisibility: payload,
            };
        case types.SET_OPTIONS:
            return {
                ...state,
                options: _.defaultsDeep({}, payload, state.options),
            };
        case types.SET_VISIBILITY:
            return {
                ...state,
                visibility: payload,
            };
        case types.UPDATE_TIMESTAMP:
            return {
                ...state,
                lastRunDuplicate: payload,
            };
        default:
            return state;
    }
};
